var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLikeTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3340_1103)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.359624 5.27246C0.163569 5.27246 0.00463867 5.43141 0.00463867 5.62745V10.8413C0.00463867 11.0374 0.163592 11.1963 0.359624 11.1963H2.49837V5.27246H0.359624Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9954 7.23252C11.9954 6.78189 11.7533 6.38673 11.3923 6.17031C11.5306 5.9706 11.6117 5.72833 11.6117 5.46754C11.6117 4.7852 11.0566 4.23006 10.3743 4.23006H7.76196C7.84202 3.86724 7.95152 3.32281 8.02776 2.75288C8.22618 1.26973 8.09057 0.44719 7.60103 0.164322C7.29583 -0.0119984 6.96677 -0.0477641 6.67445 0.0635174C6.44863 0.149533 6.14366 0.36101 5.96987 0.880035L5.2833 2.67772C4.93522 3.53734 3.86931 4.4398 3.20825 4.93881V11.3531C4.43343 11.7824 5.7119 12 7.0162 12H9.86259C10.5449 12 11.1001 11.4449 11.1001 10.7625C11.1001 10.5236 11.032 10.3002 10.9142 10.1109C11.3267 9.90998 11.6117 9.48637 11.6117 8.99753C11.6117 8.73672 11.5306 8.49449 11.3923 8.29476C11.7533 8.07834 11.9954 7.68316 11.9954 7.23252Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3340_1103"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeTag);
export default __webpack_public_path__ + "static/media/likeTag.9b4a08c708636aa8b3f0384c5fac0f55.svg";
export { ForwardRef as ReactComponent };